import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
    cartao: {
      width: '256px',
      height: '306px',
      borderRadius: 6,
      border: 'solid 1px #dfdfe6',
      backgroundColor: 'white',
      boxShadow: 'none',
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-strech',
      margin: '5px 10px 5px 20px',
      cursor: 'pointer',
      '&:hover': {
        boxShadow: '2px 2px 2px 2px #dfdfe6',
      }
    },
    shareButton: {
      position: 'absolute',
      top: 10,
      right: 10,
      color: '#044ada',
    },
    imagemReplaceFoto: {
      width: 72,
      height: 72,
      backgroundColor: '#30b0ff',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      color: 'white',
      fontSize: 24,
      fontWeight: 600,
      fontFamily: 'IBM Plex Sans',
      borderRadius: 44,
    },
    imagemReplaceFotoSmall: {
      width: 32,
      height: 32,
      backgroundColor: '#30b0ff',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      color: 'white',
      fontSize: 10,
      fontWeight: 600,
      fontFamily: 'IBM Plex Sans',
      borderRadius: 44,
      marginRight: 8,
    },
    pNome: {
      fontFamily: 'IBM Plex Sans',
      fontWeight: 'bold',
      fontSize: 16,
      color: '#061243',
      margin: 0,
      marginTop: 10,
      textAlign: 'center'
    },
    pPerfil: {
      fontFamily: 'IBM Plex Sans',
      fontSize: 13,
      color: '#061243',
      margin: 0,
    },
    pSigla: {
      fontFamily: 'IBM Plex Sans',
      fontSize: 12,
      color: '#061243',
      margin: 0,
    },
    pEmail: {
      fontFamily: 'IBM Plex Sans',
      fontSize: 13,
      color: '#061243',
      margin: 0,
      marginTop: 10,
    },
    rodape: {
      borderTop: 'solid 1px #dfdfe6',
      width: '100%',
      padding: '5px 15px',
    },
    interlocutorInfo: {
      margin: 0,
      fontFamily: 'IBM Plex Sans',
      fontSize: 12,
      color: '#061243',
    },
  });

  export default useStyles;